module.exports = __webpack_public_path__ + "static/media/shoe-L.inline.3c8c3f3e.svg";